export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  REGULAR_USER = 'REGULAR_USER'
}

export enum UserPermission {
  ADMIN = 'ADMIN',
  EXECUTOR = 'EXECUTOR',
  UN_ASSIGNED = 'UN_ASSIGNED'
}

export enum UserStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum UserType {
  BUILTIN = 'BUILTIN',
  KMSSO = 'KMSSO'
}

export enum Page {
  HOME = '/',
  ADMIN = '/admin',
  ADMIN_SETTINGS = '/admin/settings',
  ADMIN_CLIENTS = '/admin/clients',
  ADMIN_USERS = '/admin/users',
  SOURCES = '/:clientId/sources',
  DASHBOARD = '/:clientId/dashboard',
  DESTINATIONS = '/:clientId/destinations',
  JOBS = '/:clientId/jobs/:jobId',
  JOB_MGNT = '/:clientId/job-management',
  PROFILE_INFO = '/profile',
  PROFILE_PASSWORD = '/profile/password'
}

export enum PageType {
  ADMIN,
  USER,
  ANONYMOUS,
}

export enum CSTypeEnum {
  KEYS = 'Keys',
  GLOVES = 'Gloves',
  KNIVES = 'Knives',
  PISTROLS = 'Pistols',
  ASSAULT_RIFLES = 'Assault rifles',
  SNIPER_RIFLES = 'Sniper rifles',
  SMGS = 'SMGs',
  SHOTGUNS = 'Shotguns',
  MUSIC_KITS = 'Music kits',
  MACHINEGUNS = 'Machineguns',
  PINS = 'Pins',
  STICKERS = 'Stickers',
  GRAFFITI = 'Graffiti',
  CASES = 'Cases',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/enums.ts